
   <div class="verify-container">

  <div class="verify-section d-lg-block d-none">
 <app-left-ui-template
  [welcomeText]="'Verify Your Account'"
  [welcomeSubtitle]="currentMode === 'admin-verify' 
    ? 'Enter the 6-digit code sent to your email to complete admin login' 
    : 'Enter the 6-digit code sent to your email to continue resetting your password'"
></app-left-ui-template>
  </div>
 <div class="verify-code-form">
  
  <div class="form-container">  
    
    <div class="logo-container">
      
      <div class="logo">
        <i class="pi pi-shield"></i>
      </div>  
    </div>

    <h1 class="title">Verify Your Account</h1>
    <p class="subtitle">
      Enter the 6-digit code sent to your email {{ email() }}
    </p>

    <div class="form-container">
      <label class="form-label">Password</label>
      <div class="code-inputs">
        @for (digit of code(); track $index) {
          <div class="code-input">
            <input
              type="text"
              maxlength="1"
              pInputText
              [value]="digit"
              [disabled]="isVerifying() || isResendingCode()"
              (input)="onInput($event, $index)"
              (keydown)="onKeyDown($event, $index)"
              (paste)="$index === 0 ? onPaste($event) : null"
              pattern="\d*"
              inputmode="numeric"
            />
          </div>
        }
      </div>

      <button 
        pButton 
        label="Verify Code" 
        class="verify-button"
        [disabled]="isVerifying() || isResendingCode()"
        (click)="verifyCode()"
      >{{!isVerifying() ? 'Verify Code' : 'Verifying...'}}</button>

      <div class="footer-links">
        <p class="resend-text">Didn't receive the code?</p>
        <button 
          class="resend-link" 
          [disabled]="isResendingCode()"
          (click)="resendCode()"
        >
          {{isResendingCode() ? 'Resending...' : 'Resend Code'}}
        </button>
    <p class="timer-text">Code expires in <span class="expire-time">{{ timeRemaining() }}</span></p>
      </div>
    </div>
  </div>
</div>
   </div>